;function selectDate(startdateEl, enddateEl, short, submit) {

  // Check if the user only selected the start date.
  var firstDateSelected = $(startdateEl).val() == 0 ? 0 : new Date($(startdateEl).val());//this.$element.find('.first-date-selected').first();
  var lastDateSelected = $(enddateEl).val() == 0 ? 0 : new Date($(enddateEl).val());//this.$element.find('.last-date-selected').first();


  if (firstDateSelected !== 1 && lastDateSelected == 0 && submit) {
    var intervalStartDate = firstDateSelected//new Date(parseInt(firstDateSelected.attr('time')));
    $(startdateEl).val($.datepicker.formatDate('yy/mm/dd', intervalStartDate)).trigger('change');
    // Increment one day.
    intervalStartDate.setDate(intervalStartDate.getDate() + 1);
    $(enddateEl).val($.datepicker.formatDate('yy/mm/dd', intervalStartDate)).trigger('change');
  }

  var startdate = new Date($(startdateEl).val());
  var enddate = new Date($(startdateEl).val());
  enddate.setDate(enddate.getDate() + 1)

  enddate = $(enddateEl).val() == 0 ? enddate : new Date($(enddateEl).val());

  if($(startdateEl).val() == $(enddateEl).val()) {
    enddate.setDate(enddate.getDate() + 1)
    $(enddateEl).val($.datepicker.formatDate('yy/mm/dd', enddate)).trigger('change');

  }

  if (short) {
    if (startdate.getMonth() === enddate.getMonth()) {
      var date = $.datepicker.formatDate('d', startdate) + ' - ' + $.datepicker.formatDate('d M', enddate);
    } else {
      var date = $.datepicker.formatDate('d M', startdate) + ' - ' + $.datepicker.formatDate('d M', enddate);
    }
  } else {
    var date = $.datepicker.formatDate('D d M yy', startdate) + ' - ' + $.datepicker.formatDate('D d M yy', enddate);
  }

  var millisecondsPerDay = 24*60*60*1000;
  var millisBetween = startdate.getTime() - enddate.getTime();
  var days = millisBetween / millisecondsPerDay;

  return {
    date: date,
    days: days,
    startdate: startdate,
    enddate: enddate
  };
}

window.selectDate = selectDate;
